import axiosInstance from "@/lib/axios";
import type { paginatedResponse } from "@/types/api/paginated.api";

export const createApiService = <T, F extends object, D extends object>(
    resourceName: string,
) => {
    return {
        getAll: async (filters: F): Promise<paginatedResponse<T>> => {
            const { data } = await axiosInstance.get<paginatedResponse<T>>(
                `/${resourceName}/`,
                {
                    params: filters,
                },
            );
            return data;
        },
        getById: async (id: number | string): Promise<T> => {
            const { data } = await axiosInstance.get<T>(`/${resourceName}/${id}/`);
            return data;
        },
        create: async (payload: D): Promise<T> => {
            const { data } = await axiosInstance.post<T>(
                `/${resourceName}/`,
                payload,
            );
            return data;
        },
        update: async (id: number | string, payload: Partial<D>): Promise<T> => {
            const { data } = await axiosInstance.patch<T>(
                `/${resourceName}/${id}/`,
                payload,
            );
            return data;
        },
        remove: async (id: number | string): Promise<void> => {
            await axiosInstance.delete(`/${resourceName}/${id}/`);
        },
    };
};
